import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const titleFontSizeMap = {
    '2xl': theme.fontSize.huge,
    xl: theme.fontSize.huge,
    lg: theme.fontSize.large,
    md: theme.fontSize.medium,
    sm: theme.fontSize.small,
    xs: theme.fontSize.small,
    xxs: theme.fontSize.tiny,
    '3xs': theme.fontSize.tiny,
};
const subtitleFontSizeMap = {
    '2xl': theme.fontSize.small,
    xl: theme.fontSize.small,
    lg: theme.fontSize.tiny,
    md: theme.fontSize.tiny,
    sm: theme.fontSize.tiny,
    xs: theme.fontSize.tiny,
    xxs: theme.fontSize.tiny,
    '3xs': theme.fontSize.tiny,
};
const containerGapSizeMap = {
    '2xl': theme.spacing.md,
    xl: theme.spacing.md,
    lg: theme.spacing.md,
    md: theme.spacing.md,
    sm: theme.spacing.md,
    xs: theme.spacing.sm,
    xxs: theme.spacing.sm,
    '3xs': theme.spacing.sm,
};
const textsContainerGapSizeMap = {
    '2xl': pxToRem(4),
    xl: pxToRem(2),
    lg: pxToRem(2),
    md: pxToRem(0),
    sm: pxToRem(0),
    xs: pxToRem(2),
    xxs: pxToRem(2),
    '3xs': pxToRem(2),
};
const textOnSameLine = (props) => {
    if (props.$alignment !== 'horizontal') {
        return false;
    }
    if (props.$size === 'xs' || props.$size === 'xxs' || props.$size === '3xs') {
        return true;
    }
    return false;
};
const Text = styled.span `
  margin: 0;
  line-height: 110%;

  ${(props) => props.$truncate &&
    css `
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;
export const Title = styled(Text) `
  color: ${theme.semantic.foreground.primary};
  font-weight: ${theme.fontWeight.medium};
`;
export const Subtitle = styled(Text) `
  color: ${theme.semantic.text[100]};
  font-weight: ${theme.fontWeight.regular};
`;
export const TextContainer = styled.div `
  display: flex;
  min-width: 0;
`;
export const Container = styled.div `
  display: flex;
  overflow: hidden;
  align-items: ${({ $alignment }) => ($alignment === 'vertical-left' ? 'flex-start' : 'center')};
  flex-direction: ${({ $alignment }) => ($alignment === 'horizontal' ? 'row' : 'column')};
  text-align: ${({ $alignment }) => ($alignment === 'vertical' ? 'center' : 'start')};
  gap: ${({ $size }) => $size && containerGapSizeMap[$size]};

  ${TextContainer} {
    align-items: ${(props) => textOnSameLine(props) && 'flex-end'};
    flex-direction: ${(props) => (textOnSameLine(props) ? 'row' : 'column')};
    gap: ${({ $size }) => textsContainerGapSizeMap[$size]};
  }

  ${Title} {
    font-size: ${({ $size }) => titleFontSizeMap[$size]};
  }

  ${Subtitle} {
    font-size: ${({ $size }) => subtitleFontSizeMap[$size]};
  }
`;
